import queryString from 'query-string';

import history from 'shared_history';

/**
 *  Utility class for filtering a dataset in which the URL
 *  is the single source of truth for the filter set.
 * */
class UriFiltering {
  constructor(location) {
    this.location = location;
    this.history = history;
  }

  /**
   * Gets the current filter set as it is represented in the URL
   *
   * @return {Object} The current filter set.
   */
  getFilters() {
    const { search } = this.location;

    try {
      return JSON.parse(this.constructor._searchQueryToObject(search).filters);
    } catch (e) {
      return {};
    }
  }

  /**
   * Sets the `filter` parameter in the URL to a new set of filters, while preserving all other parameters
   *
   * @param {Object} newFilters The new set of filters
   * @param {Boolean} options.replace if true, replaces instead of pushes the new filter location
   */
  setFilters(newFilters, options = {}) {
    const { search } = this.location;
    const filtersPresent = Object.getOwnPropertyNames(newFilters).length !== 0;

    // noinspection JSUnusedLocalSymbols
    const { filters, page, startingAfter, endingBefore, ...query } = this.constructor._searchQueryToObject(search);

    if (filtersPresent) {
      query.filters = JSON.stringify(newFilters);
    }

    const newLocation = {
      ...this.location,
      search: `?${queryString.stringify(query)}`
    };

    if (options.replace) {
      this.history.replace(newLocation);
    } else {
      this.history.push(newLocation);
    }
  }

  static _searchQueryToObject(search) {
    return queryString.parse(search);
  }
}

export default UriFiltering;
